import { render } from "./edit-item.vue?vue&type=template&id=6a365e45&scoped=true&ts=true"
import script from "./edit-item.vue?vue&type=script&lang=ts"
export * from "./edit-item.vue?vue&type=script&lang=ts"

import "./edit-item.vue?vue&type=style&index=0&id=6a365e45&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a365e45"]])

export default __exports__